/**
 * DNS labels that mean non-production (local Vite, deployed Dev, deployed Staging).
 * Host examples: hcp.dev.healthesus.com, hcp.stg.healthesus.com
 */
export const NonProductionDeployHostLabel = {
  DEV: 'dev',
  DEVELOPMENT: 'development',
  STG: 'stg',
  STAGE: 'stage',
  STAGING: 'staging',
} as const;

export type NonProductionDeployHostLabelType =
  (typeof NonProductionDeployHostLabel)[keyof typeof NonProductionDeployHostLabel];

export const LocalHostname = {
  LOCALHOST: 'localhost',
  IPV4_LOOPBACK: '127.0.0.1',
  IPV6_LOOPBACK: '::1',
} as const;

export type LocalHostnameType = (typeof LocalHostname)[keyof typeof LocalHostname];
